<a href="tel:080031531" *ngIf="!isConnected" class="no-internet">   <span class="icon">⚠️</span>   <p>Not connected to the internet.</p>   <a >Call: 080031531</a> </a>

<router-outlet></router-outlet>
